import request from '../../utils/request';
import { Search } from '../../DTOS/AccessControlDevice/Search';

const AccessControlDeviceService = {
  search: (search: Search) => {
    return request('/accessControlDevice/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  upsert: (
    id: any,
    formData: {
      name: any;
      cameraReference: any;
      portReference: any;
    }
  ) => {
    return request('/accessControlDevice/upsert', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: id,
          name: formData.name,
          cameraReference: formData.cameraReference,
          portReference: formData.portReference
        },
      }),
    });
  },
};

export default AccessControlDeviceService;
